import UnusedSqlObjectsPage from "../../components/monitoring/unused-sql-objects-page";
import Page from "../page";

const UnusedSqlObjects = () => {
  return (
    <Page>
      <UnusedSqlObjectsPage />
    </Page>
  );
};

export default UnusedSqlObjects;
